import { action } from 'mobx';
import parseDate from '../shared/parseDate';
import ModelBase from './ModelBase';

export default class Bonus extends ModelBase {
  static className = 'Bonus';

  @action
  static fromJSON(id, json) {
    json.datTot = parseDate(json.datTot);
    json.datVanaf = parseDate(json.datVanaf);
    
    const result = super.fromJSON(id, json);

    return result;
  }
}



// WEBPACK FOOTER //
// ./src/store/Bonus.js